// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__2YU96","modalFooterButton":"ModalNotes_modalFooterButton__1oXN3"};